<div
  class="example-container flex items-center justify-center text-black"
  #tooltip="matTooltip"
  [matTooltip]="tooltipText"
  [matTooltipPosition]="position"
  matTooltipHideDelay="200"
>
  <ng-content />
</div>
